import type { TFunction } from 'i18next'

import type { PaymentMethodsSettings } from '../../../types/paymentMethods/paymentMethodsSettings'
import type { PaymentRemindersSettings } from '../../../types/paymentReminders/paymentRemindersSettings'
import { getAutomaticPaymentRemindersDefaultValues } from '../../../utils/getAutomaticPaymentRemindersDefaultValues'
import type { PaymentsAndRemindersSettingsFormValues } from '../types/paymentsAndRemindersSettingsFormValues'

interface GetPaymentsAndRemindersSettingsDefaultValuesOptions {
  paymentMethods?: PaymentMethodsSettings
  paymentRemindersSettings?: PaymentRemindersSettings
  t: TFunction
}

export const getPaymentsAndRemindersSettingsDefaultValues = (
  options: GetPaymentsAndRemindersSettingsDefaultValuesOptions,
): PaymentsAndRemindersSettingsFormValues => {
  const { paymentMethods, paymentRemindersSettings, t } = options

  return {
    automaticPaymentRemindersSettings: paymentRemindersSettings ?? getAutomaticPaymentRemindersDefaultValues(t),
    bank: paymentMethods?.bank || '',
    iban: paymentMethods?.iban || '',
    offlinePayment: paymentMethods?.offlinePayment || '',
    paypalEmail: paymentMethods?.paypalEmail || '',
    swift: paymentMethods?.swift || '',
  }
}
